/**
 * Tablica szkolna — rysowanie palcem (6 kolorów kredy + gumka).
 * Czysta logika kolorów testowalna bez Phaser.
 */

/** 6 kredek + gumka (PLAN-V2 §6 School). Kolory pastelowe — ikony proceduralne w SchoolScene. */
export const CHALK_COLORS = [
  { id: 'white', color: 0xffffff, labelPl: 'Biała' },
  { id: 'yellow', color: 0xffeb3b, labelPl: 'Żółta' },
  { id: 'pink', color: 0xff80ab, labelPl: 'Różowa' },
  { id: 'blue', color: 0x81d4fa, labelPl: 'Niebieska' },
  { id: 'green', color: 0xa5d6a7, labelPl: 'Zielona' },
  { id: 'orange', color: 0xffcc80, labelPl: 'Pomarańcz' },
] as const;

export const ERASER_ID = 'eraser';

export type ChalkToolId = (typeof CHALK_COLORS)[number]['id'] | typeof ERASER_ID;

export type BlackboardRect = {
  x: number;
  y: number;
  width: number;
  height: number;
};

/** Domyślna tablica w świecie szkoły (środek, duża). */
export const DEFAULT_BOARD: BlackboardRect = {
  x: 750,
  y: 190,
  width: 640,
  height: 160,
};

export function isPointOnBoard(
  px: number,
  py: number,
  board: BlackboardRect = DEFAULT_BOARD,
): boolean {
  const left = board.x - board.width / 2;
  const top = board.y - board.height / 2;
  return (
    px >= left &&
    px <= left + board.width &&
    py >= top &&
    py <= top + board.height
  );
}

export function chalkColorById(id: ChalkToolId): number | null {
  if (id === ERASER_ID) return null;
  const c = CHALK_COLORS.find((k) => k.id === id);
  return c ? c.color : CHALK_COLORS[0].color;
}

/** Minimalny rozmiar przycisku kredki (cel ≥64). */
export const CHALK_BUTTON_SIZE = 64;

/**
 * Buduje listę narzędzi UI (6 kolorów + gumka) z pozycjami od lewej.
 */
export function layoutChalkTools(
  originX: number,
  originY: number,
  gap = 8,
): Array<{ id: ChalkToolId; x: number; y: number; size: number; labelPl: string; color: number | null }> {
  const tools: Array<{
    id: ChalkToolId;
    x: number;
    y: number;
    size: number;
    labelPl: string;
    color: number | null;
  }> = [];
  let x = originX;
  for (const c of CHALK_COLORS) {
    tools.push({
      id: c.id,
      x,
      y: originY,
      size: CHALK_BUTTON_SIZE,
      labelPl: c.labelPl,
      color: c.color,
    });
    x += CHALK_BUTTON_SIZE + gap;
  }
  tools.push({
    id: ERASER_ID,
    x,
    y: originY,
    size: CHALK_BUTTON_SIZE,
    labelPl: 'Gumka',
    color: null,
  });
  return tools;
}
